export class ContentType {
    private static headerName = "Content-Type"
    static ApplicationJson = [ContentType.headerName, "application/json"]
    static MultipartFormData = [ContentType.headerName, "multipart/form-data"]
    static XWWWFormUrlEncoded = [ContentType.headerName, "application/x-www-form-urlencoded"]
    static ApplicationOctetStream = [ContentType.headerName, "application/octet-stream"]
}